import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import VehicleCategoryComponent from '../components/vehicle-category.component';
import { vehicleCategories } from '../../../../../../redux/vehicle-categories/action';
import { selectVehicleCategoriesQueryItems } from '../../../../../../redux/vehicle-categories/selector';

const ManagementVehicleCategory = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const vehicleCategoryQuery = useSelector(selectVehicleCategoriesQueryItems)
  const [
    selectedVehicleCategory,
    setSelectedVehicleCategory
  ] = useState<any>({})


  const fetchVehicleCategoryById = async () => {
    await dispatch(vehicleCategories.resetAction({ actionType: 'query' }))
    await dispatch(vehicleCategories.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/vehicle-categories/query`, entity: 'vehicles', jsonData: {
        Context: {},
        Records: [
          {
            Id: parmas?.id
          }
        ]

      }
    }))
  }



  const handleBasicFormChange: any = (event: any, field: string) => {
    setSelectedVehicleCategory({ ...selectedVehicleCategory, [field]: event });
  }


  useEffect(
    () => {

      if (parmas?.id > 0) {
        fetchVehicleCategoryById()
      }

    },
    []
  )
  useEffect(
    () => {

      if (vehicleCategoryQuery?.isSuccess) {
        const data = vehicleCategoryQuery?.result?.items
        const vehicleCategoryData = {
          "Id": data?.Id || 0,
          "VehicleCategoryType": data?.VehicleCategoryType,
          "VehicleCategoryBodyType": data?.VehicleCategoryBodyType,
          "VehicleCategoryFuelType": data?.VehicleCategoryFuelType,
          "VehicleEmissionStandard": data?.VehicleEmissionStandard,
          "MinimumLoadingCapacity": data?.MinimumLoadingCapacity,
          "MaximumLoadingCapacity": data?.MaximumLoadingCapacity,
          "VehicleAxleConfiguration": data?.VehicleAxleConfiguration,
          "Length": data?.VehicleDimension?.length?.value,
          "Width": data?.VehicleDimension?.breadth?.value,
          "Height": data?.VehicleDimension?.height?.value,
          "LogisticsVehicleCategoryName": data?.LogisticsVehicleCategoryName,
          "VehicleCategoryRegistration": data?.VehicleCategoryRegistration,
          "VehicleSpecialEquipment": data?.VehicleSpecialEquipment,
          "Description": data?.Description,
          "TripVehicleBasePrice": Number(data?.TripVehicleBasePrice),
        }
        setSelectedVehicleCategory(vehicleCategoryData)

      }
    },
    [vehicleCategoryQuery]
  )





  const handleFormSubmit = async (event: any) => {
    event.preventDefault();

    const vehicleCategoryData = {
      "Id": selectedVehicleCategory?.Id || 0,
      "LogisticsVehicleCategoryName": selectedVehicleCategory?.LogisticsVehicleCategoryName || "",
      "Description": selectedVehicleCategory?.Description || "",
      "VehicleCategoryType": selectedVehicleCategory?.VehicleCategoryType || "",
      "VehicleCategoryBodyType": selectedVehicleCategory?.VehicleCategoryBodyType || "",
      "VehicleCategoryFuelType": selectedVehicleCategory?.VehicleCategoryFuelType || "",
      "VehicleDimension": {
        "length": {
          "unit": "meters",
          "value": selectedVehicleCategory?.Length || 0
        },
        "breadth": {
          "unit": "meters",
          "value": selectedVehicleCategory?.Width || 0
        },
        "height": {
          "unit": "meters",
          "value": selectedVehicleCategory?.Height || 0
        }
      },
      "TripVehicleBasePrice": Number(selectedVehicleCategory?.TripVehicleBasePrice),

      "VehicleCategoryRegistration": selectedVehicleCategory?.VehicleCategoryRegistration || "",
      "MinimumLoadingCapacity": selectedVehicleCategory?.MinimumLoadingCapacity || 0,
      "MaximumLoadingCapacity": selectedVehicleCategory?.MaximumLoadingCapacity || 0,
      "VehicleEmissionStandard": selectedVehicleCategory?.VehicleEmissionStandard || "",
      "VehicleAxleConfiguration": selectedVehicleCategory?.VehicleAxleConfiguration || "",
      "VehicleSpecialEquipment": selectedVehicleCategory?.VehicleSpecialEquipment || ""
    }
    if (parmas?.id > 0) {
      await dispatch(vehicleCategories.resetAction({ actionType: 'update' }))
      await dispatch(vehicleCategories.update({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/vehicle-categories`, entity: 'vehicles', jsonData: {
          Context: {},
          Records: [
            vehicleCategoryData
          ]

        }
      }))
      await back()


    } else {
      await dispatch(vehicleCategories.resetAction({ actionType: 'create' }))
      await dispatch(vehicleCategories.create({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/vehicle-categories`, entity: 'vehicles', jsonData: {

          Context: {},
          Records: [
            vehicleCategoryData
          ]

        }
      }))

      await back()
    }
  }

  const back = async () => {
    await dispatch(vehicleCategories.resetAction({ actionType: 'query' }))
    await navigate('/management/logistics/transport/vehicle-categories')
  }

  if (vehicleCategoryQuery?.isLoading) {
    return (
      <>
        <PageLoader />
      </>
    )
  }

  return (
    <>
      <VehicleCategoryComponent
        parmas={parmas}
        handleBasicFormChange={handleBasicFormChange}
        selectedVehicleCategory={selectedVehicleCategory}
        back={back}
        handleFormSubmit={handleFormSubmit}
      />
    </>
  )

}

export default ManagementVehicleCategory;